module.exports = __webpack_public_path__ + "img/lets-start-morningpages.68f64ff1.jpg";